import React from "react";
import Minicart$ from "@deosite/sections/Minicart";
import ButtonMinimalIcon from "@deosite/components-new/buttons/ButtonMinimalIcon";
import Button from "@deosite/components-new/buttons/Button";

const Minicart = props => {
  const propsExt = {
    ...props,
    button: <ButtonMinimalIcon />,
    checkoutButton: <Button data-test={"go-to-checkout"} />
  };

  return <Minicart$ {...propsExt} />;
};
export default Minicart;
